<template>
  <div id="app">
    <link
      href="https://unpkg.com/bootstrap@4.5.2/dist/css/bootstrap.min.css"
      rel="stylesheet"
    />
    <head>
      <meta
        name="viewport"
        content="width=device-width, initial-scale=1, shrink-to-fit=no"
      />
      <title></title>
    </head>
    <app-header v-if="isAuth" class="mb-2" />
    <!-- <hr> -->
    <login v-if="!isAuth" />
    <router-view id="router" v-if="isAuth" />
  </div>
</template>

<script>
import AppHeader from "./components/AppHeader.vue";
// import ClientList from "@/views/ClientList";
import Login from "@/views/Login";
import { mapState } from "vuex";

export default {
  name: "App",
  components: {
    AppHeader,
    Login,
  },
  data: function () {
    return {};
  },
  computed: {
    ...mapState(["isAuth"]),
  },
};
</script>

<style>
@import url("https://fonts.googleapis.com/css2?family=Jost&display=swap");

#app {
  font-family: "Jost", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  background: rgba(211, 211, 211, 0.23);
  min-height: 100vh;
}

html body {
  font-family: "Montserrat", sans-serif;
}

::-webkit-scrollbar {
  width: 2px; /* ширина для вертикального скролла */
  /*height: 8px; /* высота для горизонтального скролла */
  background-color: #565a62;
}
/* ползунок скроллбара */
::-webkit-scrollbar-thumb {
  background: transparent linear-gradient(214deg, #363940 0%, #0b0b0d 100%) 0%
    0% no-repeat padding-box;
  border-radius: 9em;
}
::-webkit-scrollbar-thumb:hover {
  background-color: #363940;
}
</style>
